/* eslint-disable import/prefer-default-export */
import React, { useCallback } from 'react';
import { Outlet, ScrollRestoration, useNavigation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useRouteConfiguration } from 'context/routeConfigurationContext';
import { canonicalRoutePath } from 'util/routes';
import { locationChanged } from 'ducks/routing.duck';
import useLocationChanged from 'hooks/useLocationChanged';
import OnboardingCompleteModal from '../extensions/dashboard/components/OnboardingCompleteModal/OnboardingCompleteModal';
import FloatingOnboardingChecklistContainer from '../extensions/dashboard/components/FloatingOnboardingChecklist/FloatingOnboardingChecklistContainer';
import WelcomeScreen from '../extensions/dashboard/components/WelcomeModal/WelcomeModal';
import CookieConsent from '../extensions/cookie-consent/components/CookieConsent/CookieConsent';
import TopbarLoadingIndicator from '../components/TopbarLoadingIndicator/TopbarLoadingIndicator';

export const RootRoute = () => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const routeConfiguration = useRouteConfiguration();

  const handleLocationChanged = useCallback(
    (location) => {
      const path = canonicalRoutePath(routeConfiguration, location);
      dispatch(
        locationChanged({
          location,
          canonicalPath: path,
        })
      );
    },
    [dispatch, routeConfiguration]
  );

  useLocationChanged(handleLocationChanged);

  return (
    <>
      {navigation.state === 'loading' && <TopbarLoadingIndicator />}
      <Outlet />
      <WelcomeScreen />
      <FloatingOnboardingChecklistContainer />
      <OnboardingCompleteModal />
      <CookieConsent />
      <ScrollRestoration />
    </>
  );
};
